import { useEffect } from "react";
import ListCategories from "../components/Categories/ListCategories";

import styles from "./css/categories.module.css"

export default function Categories({ setHeader }) {

    useEffect(() => {
        setHeader(true);
    }, []);

    return (
        <div className={styles.tableContainer}>
            <ListCategories />
        </div>

    );
}